import Api from "./Api";

export default {
  /// CRUD
  async paginate(data) {
    return Api.post("/productos_publicados/paginate", data);
  },
  async sumar_stock(producto) {
    return Api.post("/productos_publicados/sumar_stock", producto);
  },
  async ocultar(producto) {
    return Api.post("/productos_publicados/ocultar", producto);
  }
};
